import apiClient from '../axios';

function getRewards(params = {}) {
  return apiClient.get('/rewards', { params });
}

export { getRewards };
